import { QUESTION_TYPES } from '../../../constants/props';

export default ({ name, text }) => {
  switch (name) {
    case QUESTION_TYPES.appointmentConsent:
      return null;
    default:
      return text;
  }
};



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/utils/getQuestionText.js